export default "__VITE_ASSET__CI5bm5Qm__"